import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import SettingsHelpHtml from 'trunks/vue/admin/components/settings/settings_container/settings_help_html.js'

class Admin__Settings__HelpHtmlsController extends Skylark.App.BaseController {
  show() {
    this._generateSettingsSidebarView('settings__help_html')
    Skylark.Libs.Ajax.get('/admin/settings/help_html.json', {
      responseType: 'json',
      success: (data) => {
        new SettingsHelpHtml({
          el: DomMaster.find('#js-settings-help_html').node,
          propsData: {
            activeTab: 'help_html',
            helpHtmlData: data
          }
        })
      }
    })
  }
}

Admin__Settings__HelpHtmlsController.include(GenerateMorePopover, SettingsNavigator)

export default Admin__Settings__HelpHtmlsController
